import { useState } from "react";

type useBonusMenuProps = {
	initValue: number;
};

export const useBonusMenu = ({ initValue }: useBonusMenuProps) => {
	const [bonusMenuAnchorEl, setBonusMenuAnchorEl] = useState<HTMLElement>();
	const [bonusValue, setBonusValue] = useState<string>(initValue?.toString() || "");

	return { bonusMenuAnchorEl, setBonusMenuAnchorEl, bonusValue, setBonusValue };
};
